<template>
    <section class="workspace-empty-state">
        <div class="workspace-empty-state__copy">
            <span class="workspace-empty-state__eyebrow">{{ displayEyebrow }}</span>
            <h2>{{ displayTitle }}</h2>
            <p>{{ displayDescription }}</p>
            <div class="workspace-empty-state__notes">
                <span v-for="note in displayNotes" :key="note">{{ note }}</span>
            </div>
        </div>
        <div v-if="showArtwork" class="workspace-empty-state__stage" aria-hidden="true">
            <div class="workspace-empty-state__covers">
                <div class="workspace-empty-state__cover workspace-empty-state__cover--back"><img src="/static/dist/img/album_null.jpg" alt="" /></div>
                <div class="workspace-empty-state__cover workspace-empty-state__cover--middle"><img src="/static/dist/img/album_null.jpg" alt="" /></div>
                <div class="workspace-empty-state__cover workspace-empty-state__cover--front"><img src="/static/dist/img/music_null-cutout.png" alt="" /></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'WorkspaceEmptyState',
    props: {
        eyebrow: { type: String, default: '' },
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        notes: { type: Array, default: () => [] },
        showArtwork: { type: Boolean, default: true }
    },
    computed: {
        displayEyebrow() {
            return this.eyebrow || this.$tt('文件详情')
        },
        displayTitle() {
            return this.title || this.$tt('选择一首音乐，开始整理')
        },
        displayDescription() {
            return this.description || this.$tt('从左侧文件夹中选择音频文件，封面、标签和文件信息会显示在这里。')
        },
        displayNotes() {
            return this.notes.length ? this.notes : [
                this.$tt('查看封面信息'),
                this.$tt('编辑音乐标签'),
                this.$tt('整理文件详情')
            ]
        }
    }
}
</script>

<style scoped>
.workspace-empty-state { display: grid; width: min(100%, 760px); min-height: min(390px, 100%); grid-template-columns: minmax(0, 1.05fr) minmax(230px, .95fr); overflow: hidden; border: 1px solid oklch(var(--bc) / .08); border-radius: 16px; background: radial-gradient(circle at 88% 24%, oklch(var(--p) / .14), transparent 15rem), linear-gradient(115deg, oklch(var(--b1) / .96), oklch(var(--b2) / .62)), oklch(var(--b1)); box-shadow: 0 20px 46px oklch(var(--bc) / .07), inset 0 1px 0 oklch(var(--b1) / .55); }
.workspace-empty-state__copy { display: flex; flex-direction: column; justify-content: center; padding: clamp(28px, 4vw, 48px); }
.workspace-empty-state__eyebrow { width: fit-content; margin-bottom: 13px; padding: 5px 10px; border-radius: 999px; color: oklch(var(--p)); background: oklch(var(--p) / .12); font-size: 12px; font-weight: 700; }
.workspace-empty-state h2 { max-width: 11ch; margin: 0; color: oklch(var(--bc)); font-size: clamp(25px, 3vw, 38px); font-weight: 800; letter-spacing: 0; line-height: 1.12; }
.workspace-empty-state p { max-width: 31ch; margin: 15px 0 0; color: oklch(var(--bc) / .62); font-size: 14px; line-height: 1.75; }
.workspace-empty-state__notes { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 22px; }
.workspace-empty-state__notes span { padding: 6px 9px; border: 1px solid oklch(var(--bc) / .1); border-radius: 8px; color: oklch(var(--bc) / .6); background: oklch(var(--b1) / .52); font-size: 12px; line-height: 1.2; }
.workspace-empty-state__stage { position: relative; display: grid; min-height: 0; place-items: center; overflow: hidden; background: linear-gradient(90deg, transparent, oklch(var(--b3) / .38)); }
.workspace-empty-state__covers { position: relative; width: min(250px, 78%); aspect-ratio: .9; }
.workspace-empty-state__cover { position: absolute; width: 72%; aspect-ratio: 1; overflow: hidden; border: 1px solid oklch(var(--bc) / .14); border-radius: 14px; background: oklch(var(--b2)); box-shadow: 0 18px 34px oklch(var(--bc) / .15); }
.workspace-empty-state__cover img { width: 100%; height: 100%; object-fit: cover; }
.workspace-empty-state__cover--back { top: 5%; left: 6%; opacity: .42; transform: rotate(-11deg); }
.workspace-empty-state__cover--middle { top: 13%; right: 4%; opacity: .7; transform: rotate(8deg); }
.workspace-empty-state__cover--front { right: 14%; bottom: 4%; display: grid; place-items: center; background: linear-gradient(135deg, oklch(var(--b1)), oklch(var(--b2))); transform: rotate(-2deg); }
.workspace-empty-state__cover--front img { width: 82%; height: 82%; object-fit: contain; opacity: .88; }
@media (max-width: 640px) { .workspace-empty-state { grid-template-columns: 1fr; } .workspace-empty-state__stage { min-height: 230px; } }
</style>
